import DateFormat from '@/assets/js/dateFormat'
// 空值
export const isEmpty = (value) => {
    return value || '-'
}
// 两位小数
export const tofix = (value, num) => {
    if (value || value == 0) {
        return value.toFixed(num) || ''
    }
}
// 时间格式化
export const time = (value, format) => {
    if (value) {
        return DateFormat.date(value, format)
    }

}


// WEBPACK FOOTER //
// ./src/assets/js/filters.js